module.exports = __webpack_public_path__ + "img/Icon_Shield.1eeaba52.svg";